import { IRootieComponent, ScreenProps } from '@components-common/types';
import { singleOrArrayToArray } from '@dirootie-extensions/javascript';
import { EnsureComponent } from '../../components-common/_shared/conditionals/EnsureComponent';
import { useWithDefaultScreen } from '@components-system';
import { Condition } from '../../components-common/_shared/conditionals/Condition';

export const RootieComponentTree = (headComponent: IRootieComponent<any>) => {
  if(!headComponent) {
    return <></>;
  }
  const { children = [], Component, props, ...rest } = headComponent;

  if (typeof Component !== 'function' && typeof Component !== 'string') {
    console.error('Invalid component type:', typeof Component, Component);
    return <div>Error: Invalid component!</div>;  // Fallback error display
  }
  if (!children || children.length === 0) {
    return <Component {...props} />;
  }
  const current = singleOrArrayToArray(children);
  if (current.length === 0) {
    return <EnsureComponent value={Component} props={{...props}}/>;
  } else {
    return (
      <Component {...props} {...rest}>
        {current.map((child, index) => (
          <RootieComponentTree {...child} key = {index + ""}/>
        ))}
      </Component>
    );
}}

let count = 0

export const RootieView = (headComponent: ScreenProps) => {
  const mergedProps = useWithDefaultScreen(headComponent) as any;
  const { view: { Component,children=[], props,...rest } } = mergedProps;
  const result = <Condition
    predicate={children?.length !== 0}
    success={<RootieComponentTree {...mergedProps.view} />}
    unsuccess={<EnsureComponent value={Component} props={{...props}}/>}
    />;
  return result;
}



